import React, {Component} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import UpdateTab from "../../components/updateTab";
import {requestGetLastUpdatePolicyForm} from "../../actions/applicationsAndPolicies";
import {
    changeUpdatePolicyField,
    changeUpdatePolicyFormData,
    getUpdateTabTagsDescription,
    prePopulateUpdateFormField,
    requestGetAllPreviousUpdates,
    requestGetUpdateQuestions,
    requestPostNoChangesUpdatePolicyForm,
    requestPostUpdatePolicyForm,
    updatePolicyAttachmentsChange
} from "../../actions/updateTab";
import {DATE_REGURAL_EXPRESSION, CANADA_COUNTRY, COUNTRY} from "../../helpers/variables";
import {fileToObjectHandle, getHtmlValidDate, isSolicitorUser} from "../../helpers/functions";
import moment from "moment";
import {
    arrayUnique,
    findQuestionById,
    getDateQuestionMaximumValue,
    getDateQuestionMinimumValue
} from "../../helpers/questions/functions";
import {
    findUpdateQuestionById
} from "../../helpers/updateTab/functions";
import updateTabProjections from "../../projections/updateTabProjections";
import {fetchApplicationByIdAfterApplicationUpdate} from "../../actions/newApplication";
import {
    POLICY_UPDATE_QUESTION_MN_FEE_EARNER_EMAIL, POLICY_UPDATE_QUESTION_MN_LAWYERS_EMAIL_ADDRESS,
    POLICY_UPDATE_QUESTION_CA_MN_REASON_CASE_REPRESENTATION_CHANGED,
    POLICY_UPDATE_QUESTION_MN_FEE_EARNER_EMAIL_INTERNAL, POLICY_UPDATE_OPT_MN_INTERNAL_TRANSFER
} from "../../helpers/constants";
import {validateAmount} from "../../helpers/functions";
import {inputType} from "../../helpers/formGroupVariants";

class UpdateTabHOC extends Component {

    componentWillReceiveProps(nextProps) {

        if(
            (this.props.updateTab.fetching || this.props.updateTab.fetchingAllPreviousUpdates) &&
            (!nextProps.updateTab.fetching && !nextProps.updateTab.fetchingAllPreviousUpdates) &&
            (nextProps.updateTab.previousUpdates.length === 0)
        ){
            this.props.prePopulateUpdateFormField({
                questionMachineName: 'ConfirmFeeEarnerCurrentlyResponsible',
                value: nextProps.applicationPolicyAgentName
            });
            this.props.prePopulateUpdateFormField({
                questionMachineName: 'FeeEarnerEmail',
                value: nextProps.applicationPolicyAgentEmail
            });
        }


        // fetch application/policy after receiving successful policy update response
        if(
            !nextProps.updateTab.posting && this.props.updateTab.posting
            && !nextProps.updateTab.badMsg
        ) {
            this.props.fetchApplicationByIdAfterApplicationUpdate({
                applicationId: this.props.applicationPolicyId
            })
        }

    }

    componentWillMount() {
        let route = this.props.router.location.pathname;
        let splitedRoute = _.split(route, '/', 4);
        let splitId = splitedRoute[3];
        this.props.getAllPreviousUpdates(splitId);
        if (!this.props.user.loggedInUser.roles.includes('User')) {
            this.props.getUpdateQuestions(splitId);
            this.props.getLastUpdatePolicy(splitId);
        }
        if (isSolicitorUser(this.props.user.loggedInUser.roles)) {
            this.props.getUpdateTabTagsDescription();
        }
    }

    _getPolicyUpdateAnswersDto = (questionId, answer) => {
        const question = _.find(this.props.updateTab.questions, qItem => {
            return qItem.id === parseInt(questionId);
        });
        if(question.inputType === inputType.text){ 
            return {
                questionId: questionId,
                optionId: null,
                text: answer,
                amount: null,
                answerAttachments:[],
                questionMachineName: question.machineName,
                inputType: question.inputType,
            }
        }
        if(question.inputType === inputType.amount){
            return {
                questionId: questionId,
                optionId: null,
                text: null,
                amount: answer,
                answerAttachments:[],
                questionMachineName: question.machineName,
                inputType: question.inputType,
            }
        }
        if(question.inputType === inputType.textArea){
            return {
                questionId: questionId,
                optionId: null,
                text: answer,
                amount: null,
                answerAttachments:[],
                questionMachineName: question.machineName,
                inputType: question.inputType,
            }
        }
        if(question.inputType === inputType.dropDown){
            const option = _.find(question.options, option => {
                return option.id.toString() === answer.toString()
            });
            return {
                questionId: questionId,
                optionId: answer,
                text: null,
                amount: null,
                answerAttachments:[],
                questionMachineName: question.machineName,
                optionMachineName: option?option.machineName:null,
                inputType: question.inputType,
            }
        }
        if(question.inputType === inputType.calendar){
            return {
                questionId: questionId,
                optionId: null,
                text: null,
                amount: null,
                date: answer ? moment(answer, 'DD/MM/YYYY').format() : null,
                answerAttachments:[],
                questionMachineName: question.machineName,
                inputType: question.inputType,
            }
        }
        if(question.inputType === inputType.multiUpload){
            return {
                questionId: questionId,
                optionId: null,
                text: null,
                amount: null,
                answerAttachments:answer,
                questionMachineName: question.machineName,
                inputType: question.inputType,
            }
        }
        if(question.inputType === inputType.upload){
            return {
                questionId: questionId,
                optionId: null,
                text: null,
                amount: null,
                answerAttachments:answer,
                questionMachineName: question.machineName,
                inputType: question.inputType,
            }
        }
    };

    isValidEmailAddress = () => {
        const { updateTab } = this.props;
    
        const emailQuestion = this._getEmailQuestion(updateTab);
        const emailValue = updateTab.formData[parseInt(emailQuestion.id)];
    
        if (COUNTRY === CANADA_COUNTRY) {
            if(!emailQuestion.isRequired && !emailValue)
                return true;
            else if (emailValue && !this._isValidEmail(emailValue))
                return false;
        }
        else if (!this._isValidEmail(emailValue))
            return false;
    
        return true;
    };

    _getAnswerForParentQuestionReason = (updateTab) => {
        const formDataAnswers = _.pickBy(updateTab.formData, (item) => item);
        const policyUpdateAnswersDtos = _.map(formDataAnswers, (fdItem, key) => this._getPolicyUpdateAnswersDto(key, fdItem));
        return policyUpdateAnswersDtos.find(answer =>
            answer.questionMachineName === POLICY_UPDATE_QUESTION_CA_MN_REASON_CASE_REPRESENTATION_CHANGED
        );
    };

    _getEmailQuestion = (updateTab) => {
        let feeEarnerEmailMachineName = POLICY_UPDATE_QUESTION_MN_FEE_EARNER_EMAIL;
        //Check if IsCaseTransferred Or InternalTransfer for canada
        if (COUNTRY === CANADA_COUNTRY) {
            const answerForParentQues = this._getAnswerForParentQuestionReason(updateTab);
            feeEarnerEmailMachineName =answerForParentQues &&  answerForParentQues.optionMachineName === POLICY_UPDATE_OPT_MN_INTERNAL_TRANSFER ? POLICY_UPDATE_QUESTION_MN_FEE_EARNER_EMAIL_INTERNAL : POLICY_UPDATE_QUESTION_MN_FEE_EARNER_EMAIL;
        }
        return updateTab.questions.find(
            (e) => e.machineName === feeEarnerEmailMachineName || e.machineName === POLICY_UPDATE_QUESTION_MN_LAWYERS_EMAIL_ADDRESS 
        );
    };

    _isValidEmail = (emailValue) => {
        return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(emailValue) && emailValue !== '';
    };


    handleUpdateTabSubmit = (evt, action) => {
        evt.preventDefault();
        let policyUpdateAnswersDtos = [];
        let sendBody = {};        
        let formData = this.props.updateTab.formData;
        let attachments = this.props.updateTab.attachments;
        if (this.props.user.loggedInUser.roles[0] === 'Solicitor') {
            if (action === '') {
                let valid = true;

                if (!this.isValidEmailAddress())                
                    {
                    valid = false;
                    this.props.changeUpdatePolicyField('notValidMail', 'Email address is not valid.');
                    this.props.changeUpdatePolicyField('badMsg', 'Email address is not valid.')
                }
                if (valid) {
                    // filter answers - include only changed answers and answered questions
                    let formDataAnswers = _.pickBy(this.props.updateTab.formData, (item, key) => {
                        if(item){
                            return item;
                        }

                        // if null answer check if previous answer of question existed and changed
                        const matchedQuestion = this.props.updateTab.questions.find(q =>
                            q.id
                            && key
                            && q.id.toString() === key.toString()
                        );
                        if(!matchedQuestion){
                            return  false;
                        }

                        const matchedQuestionAnswer = (
                            this.props.updateTab.updatePolicy
                            && this.props.updateTab.updatePolicy.policyUpdateAnswersDtos
                        )
                            ? (
                                this.props.updateTab.updatePolicy.policyUpdateAnswersDtos.find(answer =>
                                    answer.questionId
                                    && matchedQuestion.id
                                    && matchedQuestion.id.toString() === answer.questionId.toString()
                                )
                            )
                            : null;

                        if(!matchedQuestionAnswer){
                            return false;
                        }
                        if(
                            matchedQuestionAnswer.text
                            || matchedQuestionAnswer.amount
                            || matchedQuestionAnswer.date
                        ) {
                            return true;
                        }

                        return false
                    });
                    // map answer to answerDTO acceptable from the api
                    policyUpdateAnswersDtos = _.map(formDataAnswers, (fdItem, key) => ( this._getPolicyUpdateAnswersDto(key, fdItem) ) );
                    let invalidDates = _.filter(policyUpdateAnswersDtos, item => {
                        if(item.date){
                            if(!moment(item.date).isValid()){ return true}
                        }
                        return false;
                    });
                    if(invalidDates.length > 0){
                        this.props.changeUpdatePolicyField('badMsg', 'Date input is not valid.');
                        return false;
                    }

              
                    //validation for amounts
                    const invalidAmounts = policyUpdateAnswersDtos.filter(item => {
                        if (item.amount && formData[item.questionId]) {
                            const errMsg = validateAmount(formData[item.questionId], /* minimum if needed */);
                            if (errMsg !== '') {                                
                                this.props.changeUpdatePolicyField('badMsg', "Please enter a valid amount for " + this.props.updateTab.questions.find(q => q.id.toString() === item.questionId).name);
                            }
                            return errMsg !== ''; 
                        }
                        return false; 
                    });
                    
                   if (invalidAmounts.length > 0) {                       
                        return false;
                    }           

                    const filesQuestionAnswers = policyUpdateAnswersDtos.filter(item =>
                        item.answerAttachments.length > 0)

                    const duplicate = filesQuestionAnswers.filter(q => q.answerAttachments.length != arrayUnique(q.answerAttachments.map(f => f.name)).length);
                    if (duplicate.length > 0) {
                        const duplicateFilesQuestions = this.props.updateTab.questions.filter(c => duplicate.map(i => { return i.questionId }).includes(c.id.toString()))
                        this.props.changeUpdatePolicyField('badMsg', "Please remove duplicate files for questions: " + duplicateFilesQuestions.map(q => q.name).join(", "));
                        return false
                    }
                    sendBody = {
                        policyUpdateAnswersDtos: policyUpdateAnswersDtos,
                        applicationId: this.props.SelectedAppId,
                        attachment: Object.keys(attachments).length > 0 ? {
                            ...attachments,
                            tags: this.props.updateTab.tags
                        } : null,
                        action: 'Updated'
                    };
                    this.props.postUpdatePolicyForm(sendBody);
                }
            }
            else if (action === 'No changes') {
                this.props.requestPostNoChangesUpdatePolicyForm({
                    applicationId: this.props.SelectedAppId,
                    action: action
                });
            }
        }
        else {
            //todo:  sendEmailNotification flag must be included in the request post send body below
            this.props.postUpdatePolicyForm({
                applicationId: this.props.SelectedAppId,
                sendEmail: this.props.updateTab.sendEmailNotification
            });
        }
    };

    onDrop = (files) => {
        files.map((file) => this.getBase64(file));
    };

    getBase64 = (file) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let attachment = {
            name: file.name,
            encodedFile: '',
            fileType: file.type
        };
        let props = this.props;
        reader.onload = function () {
            attachment = {...attachment, encodedFile: reader.result.substring(reader.result.indexOf("base64,") + 7)};
            props.updatePolicyAttachmentsChange(attachment)
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    };

    _findResetIds = (question, answer) => {
        let ids = [];
        _.forEach(question.options, o => {
            if(o.id.toString() !== answer.toString()){
                _.forEach(o.childQuestions, cq => {
                    const matched =  findUpdateQuestionById(this.props.updateTab.questions, cq.id);
                    ids.push(matched.id);
                    ids =  [...ids, ...this._findResetIds(matched, answer)]
                });
            }
        });
        return ids;
    };


    _calculateFormData = (changedFieldId, changedFieldValue) => {
        let triggeredQuestion = findUpdateQuestionById(this.props.updateTab.questions, changedFieldId);
        if(!triggeredQuestion) return {...this.props.updateTab.formData};
        let idsToReset = this._findResetIds(triggeredQuestion, changedFieldValue);
        return _.mapValues(this.props.updateTab.formData, (data, key) => {
            return idsToReset.includes(parseInt(key))?'':data;
        });
    };

    handleSelectChange = (evt) => {
        this.props.changeUpdatePolicyField('formData', this._calculateFormData(evt.target.name, evt.target.value));
        this.props.changeUpdatePolicyFormData(evt.target.name, evt.target.value);
    };

    handleMultipleQuestionFiles = async (evt,questionId) => {
        const questionFiles = await Promise.all(evt.map(async (file) => {
            return await fileToObjectHandle(file);
          }));
        const existingFiles = this.props.updateTab.formData[questionId]
        const newValue = [...existingFiles, ...questionFiles]
        this.props.changeUpdatePolicyFormData(questionId, newValue);        
    }

    handleSingleFileQuestions = async (evt,questionId) => {
        const questionFiles = await Promise.all(evt.map(async (file) => {
            return await fileToObjectHandle(file);
          }));
        this.props.changeUpdatePolicyFormData(questionId, questionFiles);
    }
    handleDateChange = (name, value, minDate, maxDate) => {
        if (!value) { //if value is  undefined
            if (name.target.value.length >= 8) {
                let split = name.target.value.split('/');
                if (split.length === 3) {
                    if (split[2].length === 4) {
                        let d = getHtmlValidDate(name.target.value);

                        if (!name.target.value.match(DATE_REGURAL_EXPRESSION)) { //if the date is invalid
                            this.props.changeUpdatePolicyFormData(name.target.name, '');
                            return false;
                        }
                        else {
                            if (minDate) { //if minDate exists
                                let t = getHtmlValidDate(minDate);
                                if (moment(d).isBefore(t)) {
                                    this.props.changeUpdatePolicyFormData(name.target.name, '');
                                    return false;
                                }
                            }
                            if (maxDate) { //if max date exists
                                let t = getHtmlValidDate(maxDate);
                                if (moment(d).isAfter(t)) {
                                    this.props.changeUpdatePolicyFormData(name.target.name, '');
                                    return false;
                                }
                            }
                        }
                    }
                }
            }
        }


        let foundQuestion;
        if(value){
            foundQuestion = findQuestionById(name, this.props.updateTab.questions);
        } else {
            foundQuestion = findQuestionById(name.target.name, this.props.updateTab.questions);
        }

        if(foundQuestion){
            const minDate = getDateQuestionMinimumValue(foundQuestion, this.props.updateTab.formData, this.props.updateTab.questions);
            const maxDate = getDateQuestionMaximumValue(foundQuestion, this.props.updateTab.formData, this.props.updateTab.questions);
            let answer = value ? value : name.target.value;
            if(
                answer
                && (
                    (minDate && answer < minDate)
                    || (maxDate && answer > maxDate)
                )
            ) {
                this.props.changeUpdatePolicyFormData(foundQuestion.id, '')
            }
        }


        value !== undefined ? //when user wants to clear the date the value is undefined
            (this.props.changeUpdatePolicyFormData(name, value)) : this.props.changeUpdatePolicyFormData(name.target.name, name.target.value);

    };

    //if the user marks update question : is case closed as Yes then, the following question should not be mandatory
    shouldUpdateQuestionBeMandatory = (question) => {
        if(COUNTRY == CANADA_COUNTRY){
            if(question.machineName === 'HasLawyerChangedSinceLastUpdate') {return true}
            if(question.machineName === 'ConfirmDefendantsInsurers') {return true}
            if(question.machineName === 'NameOfInsurer') {return true}
        }
        if(question.machineName === 'ConfirmFeeEarnerCurrentlyResponsible') {return true}

        if(question.machineName === 'FeeEarnerEmail') {return true}

        if(question.machineName === 'IsCaseClosed') {return true}

        if(question.machineName === 'CurrentLitigationStage') {return true}

        if(question.machineName === 'OtherResultInfo') {return true}

        return true
    };
    
    render() {
        return (
            <UpdateTab
                onDropSingle = {this.handleSingleFileQuestions}
                onDropMultiple ={this.handleMultipleQuestionFiles}
                shouldUpdateQuestionBeMandatory={this.shouldUpdateQuestionBeMandatory}
                userRoles={this.props.user.loggedInUser.roles}
                textInputsColSpan={this.props.shouldInputsTakeAllSpace?'col-sm-9':'col-sm-6'}
                applicationStatus={this.props.applicationStatus}
                UserRole={this.props.UserRole}
                HandleInputChange={this.props.changeUpdatePolicyField}
                HandleSubmit={this.handleUpdateTabSubmit}
                HandleSelectChange={this.handleSelectChange}
                HandleDateChange={this.handleDateChange}
                HandleFormCompChange={this.props.changeUpdatePolicyFormData}
                OnDrop={this.onDrop}
                Store={this.props.updateTab}
            />
        )

    }
}

const mapStateToProps = (state) => {
    return {
        router: state.router,
        updateTab: state.updateTab,
        user: state.user,
        applicationPolicyAgentName: state.newApplication.selectedApplication.agentName,
        applicationPolicyAgentEmail: state.newApplication.selectedApplication.agentEmail,
        newDocumentWasAddedToCurrentPolicyUpdate: updateTabProjections.newDocumentWasAddedToCurrentPolicyUpdate(state),
        applicationPolicyStatus: state.newApplication.selectedApplication.policyStatus,
        applicationPolicyId: state.newApplication.selectedApplication.id,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getLastUpdatePolicy: (id) => {
            dispatch(requestGetLastUpdatePolicyForm(id));
        },
        getAllPreviousUpdates: (applicationId) => {
            dispatch(requestGetAllPreviousUpdates(applicationId));
        },
        getUpdateQuestions: (id) => {
            dispatch(requestGetUpdateQuestions(id))
        },
        changeUpdatePolicyField: (field, value) => {
            dispatch(changeUpdatePolicyField(field, value))
        },
        postUpdatePolicyForm: (sendBody) => {
            dispatch(requestPostUpdatePolicyForm(sendBody))
        },
        requestPostNoChangesUpdatePolicyForm: (sendBody) => {
            dispatch(requestPostNoChangesUpdatePolicyForm(sendBody));
        },
        updatePolicyAttachmentsChange: (attachment) => {
            dispatch(updatePolicyAttachmentsChange(attachment))
        },
        changeUpdatePolicyFormData: (field, value) => {
            dispatch(changeUpdatePolicyFormData(field, value))
        },
        getUpdateTabTagsDescription: () => {
            dispatch(getUpdateTabTagsDescription())
        },
        prePopulateUpdateFormField: (payload) => {
            dispatch(prePopulateUpdateFormField(payload))
        },
        fetchApplicationByIdAfterApplicationUpdate: (payload) => {
            dispatch(fetchApplicationByIdAfterApplicationUpdate(payload))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateTabHOC);